// extracted by mini-css-extract-plugin
export var cardIcon = "_64-5";
export var checkboxCard = "_64-0";
export var checkboxCardSelected = "_64-4";
export var disabled = "_64-2";
export var interactive = "_64-1";
export var outerBorder = "_64-3";
export var spacerMedium = "_64-8";
export var spacerSmall = "_64-7";
export var spacerXsmall = "_64-6";